import React from "react";
import { Building2, HardHat, Factory, Stethoscope, ShoppingBag, GraduationCap } from "lucide-react";
import { sectors } from "../mock";

const iconMap = { Building2, HardHat, Factory, Stethoscope, ShoppingBag, GraduationCap };

const Sectors = () => {
  return (
    <section className="py-20 md:py-28 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-4">
          Secteurs desservis
        </p>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-neutral-900 leading-tight max-w-2xl">
            Une expertise adaptée à <span className="text-brand">chaque environnement.</span>
          </h2>
          <p className="text-neutral-600 max-w-md text-lg">
            Du siège social au chantier isolé, nous intervenons dans tout le Grand Nord de la France (moitié nord du pays, jusqu'au sud de Paris) avec les bonnes méthodes.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {sectors.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div key={s.title} className="group bg-white border border-neutral-200 rounded-xl p-6 hover:border-brand hover:shadow-lg transition-all">
                <div className="bg-brand/10 text-brand rounded-lg w-12 h-12 flex items-center justify-center group-hover:bg-brand group-hover:text-white transition-colors">
                  <Icon size={22} />
                </div>
                <h3 className="font-heading font-bold text-lg text-neutral-900 mt-4">{s.title}</h3>
                <p className="mt-1 text-neutral-600 text-sm">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Sectors;
